import { Box, Flex } from '@chakra-ui/react';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { NOTIFICATION_EVENTS_META } from 'screens/admin/Notifications/Constants/NotificationSettingsConstants';
import { check1on1TranscriptionEnabled, checkActionPlanFeatureEnabled } from 'utils/helpers/featureFlags';

import { modifyString, StringModifier } from 'constants/copyHelpers';
import { findAndReplaceString } from 'constants/helper';

import { NetchexNotificationEventRow } from './NetchexNotificationEventRow';
import { NetchexNotificationEventTableHeader } from './NetchexNotificationEventTableHeader';

export const FIXED_COLUMN_WIDTH = 100;

export const NetchexNotificationEventTable = ({
  type,
  eventsDetailMap,
  onToggle,
  channelDetailsMap,
  renderTableName,
}) => {
  const { moduleName } = useOrganisationSettings();

  const eventsDetailWithOrderMap = Object.keys(eventsDetailMap).reduce(
    (previousValue, currentKey) => ({
      ...previousValue,
      [currentKey]: {
        ...eventsDetailMap[currentKey],
        order: NOTIFICATION_EVENTS_META[type][currentKey]?.order ?? 0,
      },
    }),
    {}
  );

  return (
    <Flex
      flexDirection="column"
      gap="8px"
      border="4px solid #EBEFF3"
      borderRadius="8px"
      padding="12px"
      paddingBottom="8px"
      background="#FFFFFF"
    >
      {renderTableName && (
        <Box color="#333333" fontWeight="600" fontSize="12px" lineHeight="14px" paddingLeft="8px">
          {findAndReplaceString(
            NOTIFICATION_EVENTS_META[type].displayName,
            modifyString(moduleName, StringModifier.PLURAL_TITLE_CASE),
            'Goals'
          )}
        </Box>
      )}
      <Flex flexDirection="column" width="100%" overflowX="auto">
        <NetchexNotificationEventTableHeader channelDetailsMap={channelDetailsMap} />
        {Object.keys(eventsDetailWithOrderMap)
          .sort((a, b) => (eventsDetailWithOrderMap[a]?.order ?? 0) - (eventsDetailWithOrderMap[b]?.order ?? 0))
          .map((k, index, array) => {
            if (
              (k === 'OOO_COMPLETION_SUMMARY' && !check1on1TranscriptionEnabled()) ||
              (k === 'REVIEW_ACTION_PLAN' && !checkActionPlanFeatureEnabled())
            ) {
              return null; // Skip rendering for OOO_COMPLETION_SUMMARY if check1on1TranscriptionEnabled() is false
            }

            const notificationEventState = {
              ENABLED: eventsDetailMap[k]?.ENABLED,
              DISABLED: eventsDetailMap[k]?.DISABLED, // of no use really on the web, maybe it's for mobile
              NOT_SUPPORTED: eventsDetailMap[k]?.NOT_SUPPORTED,
            };

            const isHiddenForNetchex = NOTIFICATION_EVENTS_META[type][k]?.isHiddenForNetchex;

            if (isHiddenForNetchex) {
              return null; // Skip rendering for events that are hidden for Netchex
            }

            return (
              <NetchexNotificationEventRow
                key={k}
                notificationEventState={notificationEventState}
                onToggle={onToggle}
                moduleType={type}
                mainEventType={k}
                channelDetailsMap={channelDetailsMap}
                isNotControlledByNotificationSettings={
                  NOTIFICATION_EVENTS_META[type]?.isNotControlledByNotificationSettings
                }
                netchexChannels={NOTIFICATION_EVENTS_META[type]?.netchexChannels}
                isLastItem={index === array.length - 1}
                {...NOTIFICATION_EVENTS_META[type][k]}
              />
            );
          })}
      </Flex>
    </Flex>
  );
};
